import { Injectable } from '@angular/core';
import { ServiceService } from './service.service';

@Injectable({
  providedIn: 'root'
})
export class ConsultasService {
    constructor(private servi: ServiceService) { }
    getServe() { return this.servi.server; }
    getListadoNormas(data) {return this.servi.post('Consultas/getListadoNormas/',data);}
    getDatosSelect() {return this.servi.get('Consultas/getDatosSelect/');}
    getListadoConsejo(data) {return this.servi.post('Consultas/getListadoConsejo/',data);}
    getListadoSuscritos() { return this.servi.get('Consultas/getListadoSuscritos/'); }
    getDatosSelectPqr() {return this.servi.get('Consultas/getDatosSelectPqr/');}
    getListadoPqr(data) {return this.servi.post('Consultas/ConsultasPqrs/',data);}
    getDataConsultasEncuestas(data) {return this.servi.post('Consultas/ConsultasEncuestas/',data);}

}